/** @format */
import angular from 'angular';
import _ from 'lodash';
import { privatePersonInfoServiceModule } from '../service/privatePersonInfo.service';
import chooseEmployeesTpl from './chooseEmployees.tpl.html';
import '../model/privatePersonBasicInfo.model';
import { errorServiceModule } from '../error-handler/legacy/errorService';

export const chooseEmployeesModule = 'sis-components.person.chooseEmployees';

(function () {
    employeeInlineSearchCtrl.$inject = [
        'commonEmployeeService',
        'commonPrivatePersonInfoService',
        '$translate',
        '$q',
        'defaultPromiseHandler',
        'personNameService',
    ];
    angular
        .module(chooseEmployeesModule, [
            errorServiceModule,
            'sis-components.service.commonEmployeeService',
            'sis-components.service.personNameService',
            privatePersonInfoServiceModule,
        ])
        .controller('EmployeeInlineSearchCtrl', employeeInlineSearchCtrl)
        .directive('chooseEmployees', chooseEmployees);

    function employeeInlineSearchCtrl(
        commonEmployeeService,
        commonPrivatePersonInfoService,
        $translate,
        $q,
        defaultPromiseHandler,
        personNameService,
    ) {
        var ctrl = this;
        ctrl.results = [];
        ctrl.selectedResults = [];

        ctrl.setSelectedResults = function (selectedEmployees) {
            if (_.isEmpty(selectedEmployees)) {
                return;
            }
            commonPrivatePersonInfoService
                .findAllByIds(selectedEmployees)
                .then(function (employees) {
                    ctrl.selectedResults = _.uniqBy(employees, 'id');
                })
                .catch(defaultPromiseHandler.loggingRejectedPromiseHandler);
        };
        ctrl.selectEmployee = function (employee) {
            ctrl.selectedEmployees.push(employee.id);
            if (ctrl.onSelect) {
                ctrl.onSelect(ctrl.selectedEmployees);
            }
        };
        ctrl.removeEmployee = function (employee) {
            _.pull(ctrl.selectedEmployees, employee.id);
            if (ctrl.onSelect) {
                ctrl.onSelect(ctrl.selectedEmployees);
            }
        };
        ctrl.doSearch = function (query) {
            if (!query || query.length < 2) {
                ctrl.results = [];
                return;
            }
            commonEmployeeService.search(query).then(
                function (results) {
                    ctrl.results = results.searchResults;

                    // Show info text if there are more search results than returned from the service
                    var more = results.total - results.start - results.searchResults.length;
                    if (more > 0) {
                        ctrl.results.push({
                            lastName: $translate.instant('EMPLOYEE_SEARCH_MORE_ITEMS', { count: more }),
                        });
                    }
                },
                function () {
                    // error
                    ctrl.results = [];
                },
            );
        };
        ctrl.getEmployeeFullName = function (employee) {
            return employee ? personNameService.getFullNameReversed(employee) : '';
        };
        ctrl.disableChoice = function (employee) {
            return !_.has(employee, 'id') || _.some(ctrl.selectedResults, { id: employee.id });
        };
    }

    function chooseEmployees() {
        return {
            restrict: 'E',
            scope: {
                onSelect: '=?',
                selectedEmployees: '=',
            },
            controller: 'EmployeeInlineSearchCtrl',
            controllerAs: 'ctrl',
            bindToController: true,
            template: chooseEmployeesTpl,
            link: function (scope) {
                scope.ctrl.setSelectedResults(scope.ctrl.selectedEmployees);
            },
        };
    }
})();
